export const zIndex = {
  header: 110,
  footer: 100,
  backButton: 99,
  mobileHorseFilters: 101,
  modal: 999
};
